
export default function BeachesSection() {
  const beaches = [
    {
      name: 'Cañaveral',
      description: 'Primera playa del recorrido, ideal para descansar y disfrutar de un baño refrescante.',
      walkTime: '20 min desde El Zaino',
      swimming: 'Apta para el baño',
      image: 'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/741f127ebf3b1842699e19a108274cd9.jpeg',
      status: 'safe'
    },
    {
      name: 'Arrecifes',
      description: 'Playa rocosa con arrecifes de coral. No apta para baño debido a corrientes fuertes.',
      walkTime: '45 min desde El Zaino',
      swimming: 'No apta para el baño',
      image: 'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/5141786d39a2f1e3fbdd40ec90db006f.jpeg',
      status: 'warning'
    },
    {
      name: 'Arenilla',
      description: 'Playa tranquila con aguas más calmadas, perfecta para relajarse.',
      walkTime: '1 hora desde El Zaino',
      swimming: 'Apta para baño',
      image: 'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/58f4eeab1b8d6a47029b8694a1f5de80.jpeg',
      status: 'safe'
    },
    {
      name: 'La Piscina',
      description: 'Aguas cristalinas y calmadas, ideal para baño y snorkel. Una verdadera piscina natural.',
      walkTime: '1.5 horas desde El Zaino',
      swimming: 'Perfecta para baño y snorkel',
      image: 'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/b2a11f239a2c4f6b63600c80f08d2114.jpeg',
      status: 'excellent'
    },
    {
      name: 'Cabo San Juan',
      description: 'La playa más icónica del Tayrona, con su famosa formación rocosa y aguas espectaculares.',
      walkTime: '2 horas desde El Zaino',
      swimming: 'Apta para baño',
      image: 'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/72be16163245c7b63cff04ba82326b64.jpeg',
      status: 'excellent'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'warning': return 'bg-amber-100 text-amber-800 border-amber-200';
      case 'safe': return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'excellent': return 'bg-emerald-100 text-emerald-800 border-emerald-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'warning': return 'ri-alert-line';
      case 'safe': return 'ri-check-line';
      case 'excellent': return 'ri-star-line';
      default: return 'ri-information-line';
    }
  };

  return (
    <section id="playas" className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            Descubre las Joyas del Parque
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explora las playas más hermosas del Caribe colombiano. Cada una con su propia personalidad y encanto único.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {beaches.map((beach, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="relative">
                <img 
                  src={beach.image}
                  alt={beach.name}
                  className="w-full h-48 object-cover"
                />
                <div className={`absolute top-4 right-4 px-3 py-1 rounded-full text-sm font-semibold border ${getStatusColor(beach.status)}`}>
                  <i className={`${getStatusIcon(beach.status)} mr-1`}></i>
                  {beach.swimming}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                  {beach.name}
                </h3>
                <p className="text-gray-600 mb-4">
                  {beach.description}
                </p>
                
                <div className="flex items-center justify-between text-sm text-gray-500">
                  <div className="flex items-center">
                    <i className="ri-walk-line mr-2 text-teal-600"></i>
                    {beach.walkTime}
                  </div>
                  <div className="flex items-center">
                    <i className="ri-swimming-pool-line mr-2 text-blue-600"></i>
                    {beach.swimming}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-teal-600 rounded-xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">
            <i className="ri-information-line mr-2"></i>
            Información Importante
          </h3>
          <p className="text-lg text-teal-100">
            Todas las playas se alcanzan caminando desde El Zaino. Recomendamos llevar agua, 
            protector solar biodegradable y calzado cómodo para el sendero.
          </p>
        </div>
      </div>
    </section>
  );
}
